import { useController, useFormContext } from 'react-hook-form';
import { EmailInputField, VerticalField } from '../../../../components/Form';
import EmailTagList from '../../../../components/EmailTagList';
import { INotificationSettingsForm } from '../types';

const EmailsNotificationsTarget = () => {
  const { control, setError, clearErrors } =
    useFormContext<INotificationSettingsForm>();

  const {
    field,
    fieldState,
    formState: { isSubmitting },
  } = useController({
    name: 'emails',
    control,
  });

  const handleChange = (email: string, emailError?: string) => {
    if (emailError) {
      setError('emails', {
        message: emailError,
        type: 'custom',
      });
    } else {
      clearErrors('emails');
    }

    if (email.length > 0) {
      field.onChange([...field.value, email]);
    }
  };
  const handlePaste = (emails: string[]) => {
    field.onChange([...field.value, ...emails]);
  };
  const handleRemoveValue = (email: string) => {
    field.onChange(field.value.filter((emailValue) => emailValue !== email));
  };

  return (
    <VerticalField noMargin={true}>
      <EmailInputField
        label={'Which email account to send notifications to? (optional)'}
        emails={field.value}
        onChange={handleChange}
        onPaste={handlePaste}
        error={fieldState.error?.message ?? null}
        disabled={isSubmitting}
      />
      {field.value.length > 0 && (
        <EmailTagList emails={field.value} onRemove={handleRemoveValue} />
      )}
    </VerticalField>
  );
};

export default EmailsNotificationsTarget;
